import api from '../../../services/Api';
import { IAuditoriaArredondamentosAjustesResultado } from '../interfaces/IAuditoriaArredondamentosAjustes';

export const AuditoriaArredondamentosAjustesService = {
  async buscarResultado(params: {
    empresaId: number;
    periodo?: string;
  }): Promise<IAuditoriaArredondamentosAjustesResultado> {
    const response = await api.get<IAuditoriaArredondamentosAjustesResultado>('auditoria-arredondamentos-ajustes/resultado', {
      params: {
        empresaIds: params.empresaId,
        periodo: params.periodo || '',
      },
    });

    return (
      response.data || {
        impactoFiscalTotal: 0,
        impactoFinanceiroTotal: 0,
        totalAvisos: 0,
        totalAlertas: 0,
        totalErros: 0,
        totalLancamentosAnalisados: 0,
        status: 'CONCILIADO',
        mensagemDirecionamento: '',
        fundamentacaoFiscal: '',
        fundamentacaoContabil: '',
        lancamentosAjuste: [],
      }
    );
  },
};
